/**
 * Clamp a value between a minimum and maximum value
 * @param value The value to clamp
 * @param min The minimum value
 * @param max The maximum value
 * @returns The clamped value
 */
const clamp = (value: number, min: number, max: number): number => {
  if (value < min) return min
  if (value > max) return max
  return value
}

/**
 * Generate a complex ID using timestamp and random values
 * @returns A complex ID string
 */
const generateComplexId = (): string => {
  return `${Date.now().toString(36)}-${Math.random().toString(36).substring(2)}-${Math.random()
    .toString(36)
    .substring(2)}`
}

export { clamp, generateComplexId }
